import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom';
import Slider from "react-slick";
import usePageContent from '../../hooks/usePageContent';

const BannerHome = () => {
    const { lang } = useParams();
    //console.log('Current language:', lang);
    const {
        fetchPageContent,
        data,
        status,
        error,
        resetStatus
    } = usePageContent();
    const [dataBanner, setDataBanner] = React.useState([]);

    useEffect(() => {
        if (status === 'idle') {
            fetchPageContent({ type: "home", field: 'Banner', language: "en-US" });
        }

        if (status === 'done') {
           setDataBanner(data === "" ? [] : JSON.parse(data));
        }
        // console.log(data);
        // console.log(status);
    }, [status])

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-one-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (

            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-one-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }
    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,


    };
    return (
        <div className="banner">
            <div className="container container-md">
                <div className="banner-item rounded-24 overflow-hidden position-relative arrow-center">
                    <a
                        href="#featureSection"
                        className="scroll-down w-84 h-84 text-center flex-center bg-main-one-600 rounded-circle border border-5 text-white border-white position-absolute start-50 translate-middle-x bottom-0 hover-bg-main-one-800"
                    >
                        <span className="icon line-height-0">
                            <i className="ph ph-caret-double-down" />
                        </span>
                    </a>
                    {/* <img
                        src="/assets/images/bg/banner-bg.png"
                        alt=""
                        className="banner-img position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 z-n1 object-fit-cover rounded-24"
                    /> */}
                    <div className="flex-align">


                    </div>
                    <div className="banner-slider">
                        <Slider {...settings}>
                            {
                                dataBanner.map((item, index) => (
                                    <div className="banner-slider__item" key={index}>
                                        <div className="banner-slider__inner flex-between position-relative">
                                            <div className="banner-item__content">
                                                <h1 className="banner-item__title bounce text-white">
                                                    {item.title}
                                                </h1>
                                                <Link
                                                    to={`/${item.buttonUrl}`}
                                                    className="btn btn-main-one-alt d-inline-flex align-items-center rounded-pill gap-8"
                                                >
                                                    {item.buttonText}{" "}
                                                    <span className="icon text-xl d-flex">
                                                        <i className="ph ph-shopping-cart-simple" />{" "}
                                                    </span>
                                                </Link>
                                            </div>
                                            <div className="banner-item__thumb">
                                                <img src={item.image} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }

                            {/* <div className="banner-slider__item">
                                <div className="banner-slider__inner flex-between position-relative">
                                    <div className="banner-item__content">
                                        <h1 className="banner-item__title text-white">
                                            Daily Grocery Order and Get Express Delivery
                                        </h1>
                                        <Link
                                            to="/products"
                                            className="btn btn-main-one-alt d-inline-flex align-items-center rounded-pill gap-8"
                                        >
                                            Buy Now{" "}
                                            <span className="icon text-xl d-flex">
                                                <i className="ph ph-shopping-cart-simple" />{" "}
                                            </span>
                                        </Link>
                                    </div>
                                    <div className="banner-item__thumb">
                                        <img src="assets/images/thumbs/banner-img1.png" alt="" />
                                    </div>
                                </div>
                            </div> */}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default BannerHome